module.exports = __webpack_public_path__ + "img/openfirehydrant.97d1a427.svg";